<template>
  <div>Edit Domains</div>
</template>

<script>
export default {};
</script>